import { Navigate, useParams } from 'react-router-dom';

import { useGetDepartamento } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import SaveDepartamentoPage from '../../shared/saveDepartamentos/saveDepartamentos';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateDepartamentoPageInterface {}

const UpdateDepartamentoPage: React.FC<UpdateDepartamentoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_departamento)
 
  const { id } = useParams();
  const { data, isLoading } = useGetDepartamento(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_departamento) return <Navigate to="/parametrizacion/departamentos" />;

  return <SaveDepartamentoPage titlePage="Editar Departamentos" editDepartamento={data.data} />;
};

export default UpdateDepartamentoPage;
